import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ScheduledTasksProvider } from "./contexts/ScheduledTasksContext";
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";

// Lazy load page components
const IndexPage = lazy(() => import("./pages/IndexPage"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const PasswordResetRequestPage = lazy(
  () => import("./pages/PasswordResetRequestPage")
);
const PasswordResetPage = lazy(() => import("./pages/PasswordResetPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));

// New pages for scheduled tasks
const TasksListPage = lazy(() => import("./pages/tasks/TasksListPage"));
const TaskDetailPage = lazy(() => import("./pages/tasks/TaskDetailPage"));
const TaskCreatePage = lazy(() => import("./pages/tasks/TaskCreatePage"));
const TaskEditPage = lazy(() => import("./pages/tasks/TaskEditPage"));
const TaskResultsPage = lazy(() => import("./pages/tasks/TaskResultsPage"));
const TaskResultDetailPage = lazy(
  () => import("./pages/tasks/TaskResultDetailPage")
);

export function App() {
  return (
    <Router>
      <AuthProvider>
        <ScheduledTasksProvider>
          <Suspense fallback={<div>Loading...</div>}>
            <Layout>
              <Routes>
                <Route path="/" element={<IndexPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route
                  path="/password-reset-request"
                  element={<PasswordResetRequestPage />}
                />
                <Route path="/password-reset" element={<PasswordResetPage />} />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <DashboardPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute>
                      <ProfilePage />
                    </PrivateRoute>
                  }
                />

                {/* Scheduled Tasks Routes */}
                <Route
                  path="/tasks"
                  element={
                    <PrivateRoute>
                      <TasksListPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/tasks/create"
                  element={
                    <PrivateRoute>
                      <TaskCreatePage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/tasks/:taskId"
                  element={
                    <PrivateRoute>
                      <TaskDetailPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/tasks/:taskId/edit"
                  element={
                    <PrivateRoute>
                      <TaskEditPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/tasks/:taskId/results"
                  element={
                    <PrivateRoute>
                      <TaskResultsPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/results/:resultId"
                  element={
                    <PrivateRoute>
                      <TaskResultDetailPage />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Layout>
          </Suspense>
        </ScheduledTasksProvider>
      </AuthProvider>
    </Router>
  );
}
